var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_1448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93655 6.61708C7.38692 6.61708 8.56198 5.55128 8.56198 4.23772C8.56198 2.92281 7.38692 1.85791 5.93655 1.85791C4.48555 1.85791 3.31055 2.92281 3.31055 4.23772C3.31055 5.55128 4.48555 6.61708 5.93655 6.61708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8561 13.8706C14.8561 13.8221 14.8472 13.7759 14.8404 13.7291L18.7621 11.1497C19.0085 10.9873 19.064 10.6733 18.8848 10.4495C18.7808 10.32 18.6135 10.2426 18.4367 10.2426C18.3194 10.2426 18.2075 10.276 18.1123 10.3383L14.1826 12.9231C14.0363 12.8626 13.8758 12.8266 13.7045 12.8266H11.5684L11.05 10.1519C10.7653 8.80326 10.168 7.74414 8.89577 7.74414H3.50202C2.22983 7.74414 0.845703 8.9985 0.845703 10.1519V18.1498C0.845703 18.7262 1.36108 19.1938 1.9972 19.1938C2.31039 19.1938 1.9972 19.1938 2.8012 19.1938L3.23902 26.0146C3.23902 26.6281 3.78827 27.1254 4.46514 27.1254C4.97264 27.1254 6.24002 27.1254 6.91689 27.1254C7.59377 27.1254 8.14252 26.6281 8.14252 26.0146L8.71777 12.5042H8.7467L9.07608 13.8221C9.18508 14.4507 9.78189 14.9142 10.4838 14.9142H13.7047C14.3407 14.9142 14.8561 14.4471 14.8561 13.8706ZM5.09733 12.388V8.5861H6.6052V12.388L5.80414 13.2443L5.09733 12.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7402 2.68066V11.3693H14.2481V4.04712H31.337V17.1048H14.2481V15.4612H12.7402V18.4713H32.8449V2.68066H12.7402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3341 22.0021C20.3341 20.9372 19.3819 20.0747 18.2073 20.0747C17.0323 20.0747 16.0801 20.9372 16.0801 22.0021C16.0801 23.0661 17.0323 23.9295 18.2073 23.9295C19.3818 23.9295 20.3341 23.0661 20.3341 22.0021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2071 24.9619C16.6909 24.9619 15.403 25.8636 14.9082 27.1255H21.506C21.0113 25.8635 19.7233 24.9619 18.2071 24.9619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.506 22.0021C29.506 20.9372 28.5538 20.0747 27.3792 20.0747C26.2041 20.0747 25.252 20.9372 25.252 22.0021C25.252 23.0661 26.2041 23.9295 27.3792 23.9295C28.5538 23.9295 29.506 23.0661 29.506 22.0021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.379 24.9619C25.8628 24.9619 24.5749 25.8636 24.0801 27.1255H30.6779C30.1831 25.8635 28.8952 24.9619 27.379 24.9619Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_1448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 29,
    fill: "white",
    transform: "translate(0.845703 -0.00830078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/sessions.8c924833a9d7df4db098690c5a2e37d3.svg";
export { ForwardRef as ReactComponent };